import { ReactNode } from "react";
import { motion } from "framer-motion";

import { DiamondsFour } from "@phosphor-icons/react";
import { Checkbox, Label } from "@reactive-resume/ui";
import { useCoverLetterStore } from "@/client/stores/cover-letter";
import { cn, coverLetterTemplatesList } from "@reactive-resume/utils";

import { CLCollapsibleSection } from "../../../CollapsibleSection";

export const CLTemplateSection = () => {
  const setValue = useCoverLetterStore((state) => state.setValue);
  const currentTemplate = useCoverLetterStore(
    (state) => state.coverLetter?.data?.metadata?.template,
  );
  const hideIcons = useCoverLetterStore(
    (state) => state.coverLetter?.data?.metadata?.typography?.hideIcons,
  );

  const headerHTML: ReactNode = (
    <div className="flex items-center gap-x-4">
      <DiamondsFour size={18} />
      <span className="line-clamp-1 text-base font-bold text-gray-800 lg:text-lg">Template</span>
    </div>
  );

  const contentHTML: ReactNode = (
    <div className="rounded-md bg-[#E3E3E380] p-3">
      <main className="grid grid-cols-2 gap-8 @lg/right:grid-cols-3">
        {coverLetterTemplatesList.map((template, index) => (
          <motion.div
            key={template}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { delay: index * 0.1 } }}
            whileTap={{ scale: 0.98, transition: { duration: 0.1 } }}
            className={cn(
              "relative cursor-pointer rounded-sm border-2 p-3 text-center transition-all hover:border-primary",
              currentTemplate === template ? "border-primary bg-primary/5" : "border-transparent",
            )}
            onClick={() => setValue("metadata.template", template)}
          >
            <p className="text-sm font-bold capitalize text-primary">{template}</p>
          </motion.div>
        ))}
      </main>

      {currentTemplate === "professional" && (
        <div className="mt-4 flex items-center space-x-2 rounded-md border border-gray-200 bg-white p-3 shadow-sm">
          <Checkbox
            id="disable-professional-icons"
            checked={hideIcons}
            onCheckedChange={(checked) => setValue("metadata.typography.hideIcons", !!checked)}
          />
          <Label
            htmlFor="disable-professional-icons"
            className="cursor-pointer text-sm font-medium text-gray-800"
          >
            Disable icons on Professional template
          </Label>
        </div>
      )}
    </div>
  );

  return (
    <CLCollapsibleSection id="cl-template" header={headerHTML} defaultOpen={true} content={contentHTML} />
  );
};
